import { render, staticRenderFns } from "./selector.vue?vue&type=template&id=fc2ef292&scoped=true"
import script from "./selector.vue?vue&type=script&lang=js"
export * from "./selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2ef292",
  null
  
)

export default component.exports